module.exports = __webpack_public_path__ + "static/tp-product-28892ffdb795dbf9c4574cdd9cbfa6c7.png";